import { REDESIGN_ASSETS_BASE } from 'constants/redesign'

export const NEIGHBARS_SURVEY_ID: number | null = 22

// Campaign closure switch (Figma "Cierre dinámica", node 5606:4894): when
// true the survey is never fetched and logged users see the "promotion has
// ended" card where the form used to render.
export const NEIGHBARS_CAMPAIGN_CLOSED = true

// Survey 22 names its postal-code question just "CP", so the text fallback
// ("codigo postal") does not apply — match it by its official questionId.
export const NEIGHBARS_CP_QUESTION_ID: number | null = 53

export const NEIGHBARS_ASSETS = REDESIGN_ASSETS_BASE

export const NEIGHBARS_VIDEOS = {
  // Hero and bottom CTA share the same UCL TVC spot (canvas note); the 9x16
  // cut fits the tall hero, the 4x5 cut fits the mid section and CTA block.
  // Desktop layouts (Figma 26:474) use the horizontal 16x9 cut.
  hero: 'MX_FHMF_ND - TVC UCL_9x16_10SECONDS_00B33_Mexico.mp4',
  campaign: 'MX_FHMF_ND - TVC UCL_4x5_10SECONDS_00B33_Mexico.mp4',
  heroDesktop: '20251520_HEINEKEN-GLOBAL_Sponsorship2026_LePub-Assets_UCL_TVC_30s_16x9_[MX_MEXICO]_[VIX].mp4'
}
